import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../App';

interface ProtectedRouteProps {
    children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const adminEmail = process.env.REACT_APP_ADMIN_EMAIL;

    if (loading) {
        return (
            <div className="mx-auto max-w-3xl md:border-x px-4 py-24">
                <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-foreground" />
                </div>
            </div>
        );
    }

    if (!user || user.email !== adminEmail) {
        return <Navigate to="/admin/login" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
